module.exports = __webpack_public_path__ + "img/slash-square-fill.2fb615b9.svg";